import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import indianapolis__asset from "@/assets/restore/locations/indianapolis.jpg.asset.json";

const cities: StateCity[] = [
  {
    name: "Indianapolis",
    address: "450 E. 96th St, Suite 500",
    img: indianapolis__asset.url,
    mapUrl:
      "https://www.google.com/maps/search/?api=1&query=450+E+96th+St+Indianapolis+IN",
    to: "/locations/indiana/indianapolis/",
  },
];

export const Route = createFileRoute("/locations/indiana/")({
  head: () => ({
    meta: [
      { title: "Indiana Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Indiana. Book a free personal hair loss consultation at our Indianapolis location and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Indiana Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in Indianapolis, Indiana and book a free consultation to learn about the FUE procedure.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/indiana/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/indiana/" }],
  }),
  component: () => <StateLocationsHub stateName="Indiana" cities={cities} />,
});